import { render, staticRenderFns } from "./severity_badge.vue?vue&type=template&id=211108a6&"
import script from "./severity_badge.vue?vue&type=script&lang=js&"
export * from "./severity_badge.vue?vue&type=script&lang=js&"
import style0 from "./severity_badge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports